module.exports = __webpack_public_path__ + "static/media/b99-post-mid.156ed4e7.png";